/**
 * Versandbedingungen als Fenster, ausgeloest vom Wort "Versand" im Hinweis
 * "Versand wird beim Checkout berechnet." (snippets/md-volume-discount.liquid).
 *
 * Bewusst eine eigene Datei mit defer statt eines Inline-Skripts: Ein synchrones
 * Skript mitten im Body haelt den Parser an, der Browser zeichnet daraufhin die
 * noch unfertige Seite -- der Kopf erscheint kurz in seinem Zustand vor dem
 * Menue-Skript, die Widgets der Kaufspalte klappen erst danach auf. Inline war
 * das als Layout Shift von 0,06 messbar, mit defer bleibt es bei 0,0004.
 */
(function () {
  var MODAL_ID = 'md-shipping-modal';

  /**
   * Holt das Fenster aus der Kaufspalte an das Ende von body.
   *
   * Die Spalte liegt in .product-info__sticky, und position: sticky erzeugt einen
   * Stapelkontext -- unabhaengig davon, ob ein z-index gesetzt ist. Darin wirkt
   * jeder z-index nur noch innerhalb der Spalte. Der Kopf der Seite ist ein
   * eigener Stapelkontext direkt unter body mit z-index 30 und legt sich sonst
   * ueber das Fenster. Mit CSS ist daran nichts zu aendern: Aus einem
   * Stapelkontext kommt man nicht heraus, auch nicht mit einem hoeheren Wert.
   *
   * Das Theme umgeht das bei seinen Pop-up-Bloecken genauso, nur schon beim
   * Rendern -- sections/main-product.liquid ruft 'product-popups' hinter allen
   * schliessenden divs der Spalte auf.
   */
  function anBodyHaengen() {
    var nodes = document.querySelectorAll('.md-shipping-modal');
    var frisch = null;
    var alt = [];

    for (var i = 0; i < nodes.length; i += 1) {
      // Was schon an body haengt, stammt aus einem frueheren Durchlauf: Der
      // Theme-Editor rendert die Section bei jeder Aenderung neu, das
      // verschobene Fenster ueberlebt das aber und waere sonst ein Doppel mit
      // derselben id.
      if (nodes[i].parentElement === document.body) {
        alt.push(nodes[i]);
      } else {
        frisch = nodes[i];
      }
    }

    if (!frisch) return;

    for (var j = 0; j < alt.length; j += 1) alt[j].remove();
    document.body.appendChild(frisch);
  }

  function klickAbfangen(evt) {
    var target = evt.target;
    if (!target || !target.closest) return;

    var ausloeser = target.closest('[data-md-shipping-modal]');
    if (!ausloeser) return;

    // Mittelklick und Strg/Cmd/Shift dem Browser ueberlassen -- wer den Link
    // bewusst in einem neuen Tab oeffnet, will kein Fenster ueber der aktuellen
    // Seite.
    if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

    var modal = document.getElementById(MODAL_ID);
    // Ohne modal.open fehlt die Custom-Element-Klasse aus assets/main.js. Dann
    // bleibt der Klick unangetastet und der Link fuehrt auf die
    // Richtlinienseite.
    if (!modal || typeof modal.open !== 'function') return;

    evt.preventDefault();
    modal.open(ausloeser);
  }

  anBodyHaengen();

  if (window.mdShippingModalBound) return;
  window.mdShippingModalBound = true;

  // Delegiert am Dokument statt am Link selbst: Das Widget schreibt seine
  // Preiszeilen bei jeder Regleraenderung neu, an frischem Markup haengen keine
  // Listener mehr.
  document.addEventListener('click', klickAbfangen);

  // Erst hier, wo feststeht, dass der Klick auch abgefangen wird: Ohne
  // JavaScript ist der Ausloeser ein gewoehnlicher Link und duerfte kein
  // Dialogverhalten ankuendigen.
  document.querySelectorAll('[data-md-shipping-modal]').forEach(function (el) {
    el.setAttribute('aria-haspopup', 'dialog');
  });
})();
